import { type ReactNode, useState } from 'react'

import { Button } from '@/components/ui/button'

/** A document the carrier should go and find, set apart from the prose around it. */
function Doc({ children }: { children: ReactNode }) {
  return <strong className="font-semibold">{children}</strong>
}

/**
 * The vault in manageable pieces: one ask at a time, in the order a carrier
 * benefits from doing them. Append to the end — the numbering follows the list.
 */
function tips(intakeEmail?: string): ReactNode[] {
  return [
    <>
      DOT inspection by the FMCSA typically requires you send documents within 48 to 72 hours. Get started by
      uploading your <Doc>annual DOT inspection</Doc>, <Doc>annual MVR review and notes</Doc>, and{' '}
      <Doc>accident register</Doc>.
    </>,
    <>
      Try forwarding any work orders, invoices, shop tickets, or in-house logs for your fleet
      {intakeEmail ? <> to {intakeEmail}</> : ' in'}. DOT inspections by the FMCSA will require{' '}
      <Doc>preventive maintenance records</Doc> on your equipment.
    </>,
  ]
}

export function VaultTips({ intakeEmail }: { intakeEmail?: string }) {
  const [index, setIndex] = useState(0)
  const TIPS = tips(intakeEmail)
  const tip = TIPS[index]
  if (!tip) return null

  return (
    <div className="flex flex-col items-start gap-3">
      {/* Polite, so the new tip is announced without interrupting whatever is being read. */}
      <p aria-live="polite" className="text-md">
        {tip}
      </p>
      {TIPS.length > 1 && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIndex((current) => (current + 1) % TIPS.length)}
        >
          Next
        </Button>
      )}
    </div>
  )
}
